<template>
	<div>
		<Card>
			<Spin v-if="innerSpin"
			    size="large"
			    fix></Spin>
			<transition name="fade">
			    <Row v-if="mainTable.sarchCardShow"
			        :gutter="16">
			        <Col span="24">
			        <search-card :form="mainTable.searchForm"
			            :table-load-event="getAreaTableRecords"
			            :table-search="mainTable.tableSearch" />
			        </Col>
			    </Row>
			</transition>
			<Row :gutter="16">
			    <Col span="24">
			    <div class="global-tool-bar">
			        <div class="left-bar">
			            <span class="title">区域管理</span>
			        </div>
			        <div class="right-bar">
			            <Button 
			                class="btns"
			                size="small"
			                shape="circle"
			                type="success"
			                icon="ios-add-circle-outline"
			                @click="onAreaCreate">新增</Button>
			            <Button type="primary"
			                size="small"
			                class="btns"
			                shape="circle"
			                icon="ios-search"
			                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
			        </div>
			    </div>
			    </Col>
			</Row>
			<Row :gutter="16">
			    <Col span="24">
			    <stand-pagination-table :columns="mainTable.columns"
			        :data="mainTable.data"
			        :loading="mainTable.loading"
			        :table-search="mainTable.tableSearch"
			        :table-load-event="getAreaTableRecords" />
			    </Col>
			</Row>

        <Modal v-model="areaFormShow"
            title="区域信息">
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="区域名称">
                        <Input v-model="areaForm.areaName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="区域代码">
                        <Input v-model="areaForm.areaCode"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="备注">
                        <Input v-model="areaForm.areaRemark"></Input>
                    </FormItem>
                    </Col>
					<Col span="12">
					<FormItem label="状态">
					    <RadioGroup v-model="areaForm.areaStatus"
					        type="button">
					        <Radio v-for="item in approvalSource"
					            :key="item.val"
					            :label="item.val">{{ item.label }}
					        </Radio>
					    </RadioGroup>
					</FormItem>
					</Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="success"
                    class="form-button"
                    @click="onSave">保存</Button>
                <Button type="text"
                    class="form-button"
                    @click="onCancel">取消</Button>
            </div>
        </Modal>

    </Card>
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { STATUS_ACTIVE, STATUS_INACTIVE, statusFormat } from '@/libs/baseModelFormat';
import { getAreaList, saveArea } from '@/api/modules/system-management/area-management';

export default {
    name: 'AreaList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            areaForm: {
                formEditMode: '',
                areaUuid: '',
                areaName: '',
                areaCode: '',
                areaRemark: '',
                areaStatus: STATUS_ACTIVE
            },
            approvalSource: [],
            innerSpin: false,
            areaFormShow: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '区域名称', key: 'areaName', align: 'center' },
                    { title: '区域代码', key: 'areaCode', align: 'center' },
                    { title: '备注', key: 'areaRemark', align: 'center' },
                    {
					    title: '状态',
					    key: 'areaStatus',
					    align: 'center',
					    render: (h, params) => {
					        return h('div', [
					            h('span', {}, statusFormat(params.row.areaStatus))
					        ]);
					    }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onAreaUpdate(params.row);
                                        }
                                    }
                                }, '编辑')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '区域名称', type: 'Input', value: '', name: 'areaName', sql: 'like' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getAreaTableRecords();
    },
    methods: {
        getAreaTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getAreaList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.approvalSource = [];
                this.approvalSource.push({ val: STATUS_ACTIVE, label: statusFormat(STATUS_ACTIVE) });
                this.approvalSource.push({ val: STATUS_INACTIVE, label: statusFormat(STATUS_INACTIVE) });
                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        onAreaCreate() {
            this.areaForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.areaForm.areaUuid = '';
            this.areaForm.areaName = '';
            this.areaForm.areaCode = '';
            this.areaForm.areaRemark = '';
            this.areaForm.areaStatus = STATUS_ACTIVE;
            this.areaFormShow = true;
        },
        onAreaUpdate(row) {
            this.areaForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.areaForm.areaUuid = row.areaUuid;
            this.areaForm.areaName = row.areaName;
            this.areaForm.areaCode = row.areaCode;
            this.areaForm.areaRemark = row.areaRemark;
            this.areaForm.areaStatus = row.areaStatus;
            this.areaFormShow = true;
        },
        onCancel() {
            this.areaFormShow = false;
        },
        onSave() {
            const data = Object.assign({}, this.areaForm);
            saveArea(data).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.areaFormShow = false;
                            this.getAreaTableRecords();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
</style>
